import { find } from "./base";
import { user as getUser } from "./users";
import { formalizedPhone } from "helpers/helper";
import { getLeadTracking } from "lib/leadTracking";

const AUTH = ["authentication"];

/**
 * Helpers
 */
const has =
  (u) =>
  (...fields) =>
    u && fields.every((field) => !!u[field]);

/**
 * Session
 */
export const authenticated = (state) => () => !!find(state)(AUTH, "userId");

export const userId = (state) => () => find(state)(AUTH, "userId");

export const stripeId = (state) => () => find(state)(AUTH, "stripe_id");

const _user = (state) => getUser(state)(userId(state)());

export const user = (state) => () => _user(state);
export const currentZip = (state) => () => find(state)(AUTH, "zip");

/**
 * Profile completion
 */

export const leadTracking = (state) => () => getLeadTracking(state);

export const hasFullAddress = (state) => () =>
  has(_user(state))("street", "postal_code");

export const hasPhone = (state) => () => has(_user(state))("phone");

export const getPhone = (state) => () => formalizedPhone(_user(state)?.phone);

// Check if email is a placeholder from phone-only OTP signup
export const hasPlaceholderEmail = (state) => () => {
  const u = _user(state);
  return u?.email?.includes("@placeholder.dwellsocial.com");
};

export const hasRealEmail = (state) => () => {
  const u = _user(state);
  return u?.email && !u.email.includes("@placeholder.dwellsocial.com");
};

export const complete =
  (state) =>
  (full = true) => {
    const u = _user(state);
    if (!u) return false;

    // Check name (at least 3 characters)
    const hasName = u.name && u.name.trim().length >= 3;

    // Check basic required fields
    const hasBasicFields = has(u)(
      ...(full ? ["street", "phone", "postal_code"] : ["postal_code"])
    );

    // Also require a real email (not a placeholder from phone OTP signup)
    const hasEmail =
      u.email && !u.email.includes("@placeholder.dwellsocial.com");

    return hasName && hasBasicFields && hasEmail;
  };

/**
 * General Application State
 */
export const tab = (state) => () => find(state)(AUTH, "tab");

export const version = (state) => () => find(state)(AUTH, "version");
